import React,{useState,useEffect} from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  WorkPositionDatatable = (props) => {

    const [t] = useTranslation();     
    const [entityId, setEntityId] = useState();
    const tableName = t('basicData.label.departments');     
 

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('user.label.positionCode'), data: "positionCode", sortable: true, selector: "positionCode"},    		
             { name: t('user.label.positionName'), data: "positionName", sortable: true, selector: "positionName"}    		
                   
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('user.label.positionCode'), data: "positionCode",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('user.label.positionName'), data: "positionName", orderable: true,  searchable: true, search: {value: '',regex: false}}                    
     ];        
     const url = RestService.getBaseURL()+"user/getWorkPositionsTableList";    
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 
     useEffect(() => {      
        setEntityId(props.entityId);
      }, [props.entityId])

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
    
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
           
         );
    
 
  
 };

export default WorkPositionDatatable;

